<template>
  <AppModal v-bind="$attrs" v-model="value" max-width="750px" persistent :disable-close="loading">
    <template v-slot:title>
      Add Alias
    </template>
    <template v-slot:text>
      <p>
        {{$t('MonitoringFeatureAlias.aliasCanContainDataMsg')}}
      </p>
      <v-form ref="form" v-model="formIsValid">
        <v-text-field required v-model="synonymNameFormField.value" label="Alias name" :rules="synonymNameFormField.rules">
        </v-text-field>
        <template v-if="isSystemAdmin">
          <v-subheader class="pl-0">System Administrator Settings</v-subheader>
          <v-checkbox color="info" class="mt-0" v-model="formIsPrimary" label="Make primary alias" persistent-hint hint="The primary alias is the name used in reports"></v-checkbox>
        </template>
      </v-form>
      <v-alert key="alert" outline class="my-0" type="warning" :value="formIsPrimary">
        <div class="primary--text">
          The primary alias name shows up in reports, which may cause confusion when the primary alias does not match
          the location name.
        </div>
      </v-alert>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn color="success" :loading="loading" :disabled="!formIsValid" @click="submit">
        <v-icon class="mr-1">done</v-icon> {{$t('Button.Save')}}
      </v-btn>
      <v-btn outline color="secondary" @click="close" :disabled="loading">{{$t('Button.Close')}}</v-btn>
    </template>
  </AppModal>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const app = createNamespacedHelpers('app')
  const authenticate = createNamespacedHelpers('authenticate')
  const synonyms = createNamespacedHelpers('synonyms')
  const datasource = createNamespacedHelpers('datasource')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    props: {
      dataSourceIndex: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        value: false,
        formIsValid: true,
        formIsPrimary: false,
        synonymNameFormField: {
          value: '',
          rules: [v => !!v || 'Required', v => !this.allVegetativeSynonyms.includes(v) ||
            `Synonym ${v} already exists`,
          ],
        },
        loading: false,
      }
    },
    computed: {
      ...authenticate.mapGetters(['isSystemAdmin']),
      ...datasource.mapGetters(['getDataSourcesGivenMF']),
      vegetativeDataSources() {
        return this.getDataSourcesGivenMF(SOURCE_TYPES.vegetativeMonitoringEnvirodata)
      },
      allVegetativeSynonyms() {
        return this.vegetativeDataSources.reduce((acc, ds) => {
          const dataSourceSynonymNames = (ds && ds.Synonyms && ds.Synonyms.map(x => x.Name)) || []
          return [...acc, ...dataSourceSynonymNames]
        }, [])
      },
    },
    watch: {
      value() {
        if (!this.value) {
          this.reset()
        }
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...datasource.mapActions(['fetchDataSources']),
      ...synonyms.mapActions(['addSynonym']),
      show() {
        return this.value = true
      },
      close() {
        this.loading = false
        this.value = false
        this.reset()
      },
      reset() {
        this.synonymNameFormField.value = ''
        this.formIsPrimary = false
        this.$refs['form'].resetValidation()
      },
      async submit() {
        if (!this.$refs.form.validate()) return
        try {
          this.loading = true
          await this.addSynonym({
            synonymName: this.synonymNameFormField.value,
            isPrimary: this.formIsPrimary,
            sourceType: SOURCE_TYPES.vegetativeMonitoringEnvirodata,
            sourceId: this.dataSourceIndex.Id,
            synonymData: {},
          })
          await this.refresh()

          this.setSnackbar({
            text: `Alias ${this.synonymNameFormField.value} added successfully`,
            color: 'success',
            icon: 'done',
          })

          this.close()
        } catch (err) {
          this.setSnackbar({
            text: err.Message || err,
            color: 'error',
            icon: 'error',
          })
        } finally {
          this.loading = false
        }
      },
      async refresh() {
        await this.fetchDataSources({
          sourceTypes: [SOURCE_TYPES.vegetativeMonitoringEnvirodata],
        })
      },
    },
    beforeDestroy() {
      this.reset()
    },
  }
</script>